import React from 'react'

import Heading from 'components/Heading/Heading'
import ReviewsModal from 'components/ReviewsModal/ReviewsModal'
import useRouter from 'hooks/useRouter'

import ReviewRating from '../ReviewRating/ReviewRating'
import { ProfileAndClassNameProps } from '../type'

import styles from './Information.module.css'

const Information = ({ profile }: ProfileAndClassNameProps): JSX.Element => {
  const router = useRouter()

  if (!profile?.name) return null

  return (
    <div className={styles.information} data-cy="profilePageInformation">
      <Heading>
        <h1 className={styles.informationName}>{profile.name}</h1>
      </Heading>

      {profile.title && (
        <div className={styles.informationTitle}>{profile.title}</div>
      )}

      {profile.averageReviewRating > 3 && (
        <>
          <ReviewRating
            rating={profile.averageReviewRating}
            reviewCount={profile.reviewCount}
          />

          {!!router.query.reviews && <ReviewsModal />}
        </>
      )}
    </div>
  )
}

export default Information
